export const getLanguageFromStorage = () => {
  if (typeof "window" !== undefined) {
    const storedLng = window.localStorage["gatsby-i18next-language"];
    if (!storedLng) {
      window.localStorage["gatsby-i18next-language"] = navigator.language;
    }
  }
};
